import reducer from "./reducers";

import * as patientsActions from "./actions";

export { patientsActions };

export default reducer;
